// @ts-nocheck
import accountSettingsReducer, {
    AccountSettingsActions,
} from "@store/Framework/Store/Starter/Pages/AccountSettings/AccountSettingsReducer";
import blogCategoryReducer, {
    BlogCategoryActions,
} from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategoryReducer";
import productListReducer, {
    ProductListActions,
} from "@store/Framework/Store/Starter/Pages/ProductList/ProductListReducer";
import { combineReducers } from "redux";

const pagesReducer = combineReducers({
    accountSettings: accountSettingsReducer,
    blogCategory: blogCategoryReducer,
    productList: productListReducer,
});

export type PagesActions = AccountSettingsActions | BlogCategoryActions | ProductListActions;

export default pagesReducer;
